export enum WorkerRole {
    Owner = 1,
    Employee = 2,
    Administrator = 3
}